module.exports = __webpack_public_path__ + "static/media/26.f92cd71f.png";